// Attaches the MSAL ID token to status polling (/api/status/{instanceId}).
// The backend verifies it and only returns the status to the user who started the orchestration.
// Class-based (HTTP_INTERCEPTORS) on purpose: several components import HttpClientModule
// themselves, and only DI interceptors from the root injector reach those HttpClient instances.

import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, catchError, from, switchMap } from 'rxjs';

@Injectable()
export class StatusAuthInterceptor implements HttpInterceptor {
  constructor(private msalService: MsalService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!req.url.includes('/api/status/')) {
      return next.handle(req);
    }

    const account =
      this.msalService.instance.getActiveAccount() ||
      this.msalService.instance.getAllAccounts()[0];
    if (!account) {
      console.warn('⚠️ No MSAL account found for status polling:', req.url);
      return next.handle(req);
    }

    return from(
      this.msalService.instance.acquireTokenSilent({
        scopes: ['user.read'],
        account,
      }),
    ).pipe(
      switchMap((result) =>
        next.handle(
          req.clone({
            setHeaders: { Authorization: `Bearer ${result.idToken}` },
          }),
        ),
      ),
      catchError((err) => {
        console.error('❌ Token acquisition for status polling failed:', err);
        return next.handle(req);
      }),
    );
  }
}
